import * as actions from "./actionTypes";

export const fetch = (query: any) => {
  return { type: actions.FETCH, query };
};
